import axiosTokenInstance from "../../../services/api/backoffice";

import {
    INCIDENCE_CATEGORY,
    INCIDENCE_CATEGORY_ERROR,
} from "_models/redux/types";

// Action function
export const getIncidenceCategory = (params) => async (dispatch) => {
    const { token, key, new_password } = params || {
        token: undefined,
        key: undefined,
        new_password: undefined,
    };

    const data = {
        token,
        key,
        new_password,
    };
    // Endpoint: Try & Catch
    try {
        const response = await axiosTokenInstance.get(
            `/api/catalogs/support-tickets-categories`
        );

        const { data } = response || {};

        dispatch({
            type: INCIDENCE_CATEGORY,
            payload: data || {},
        });
    } catch (e) {
        dispatch({
            type: INCIDENCE_CATEGORY_ERROR,
            payload: e || {},
        });
    }
};
